import { v as vuesticComponents } from "../components-b0642296.mjs";
import { s as setCurrentApp } from "../../current-app-1538613c.mjs";
import { u as usePlugin } from "../utils/use-plugin-11255fbd.mjs";
import { G as GlobalConfigPlugin } from "../../global-config/plugin/index-8a8b88ef.mjs";
import { C as ColorConfigPlugin } from "../../color/plugin/index-322fa67f.mjs";
import { C as CachePlugin } from "../../cache/plugin/index-3da9421a.mjs";
import { C as ColorsClassesPlugin } from "../../colors-classes/plugin/index-d50dd4f9.mjs";
import { B as BreakpointConfigPlugin } from "../../breakpoint/plugin/index-05ae1524.mjs";
import { V as VaDropdownPlugin } from "../../../components/va-dropdown/plugin/index-89360c2b.mjs";
import { V as VaToastPlugin } from "../../../components/va-toast/plugin/index-3bea9d89.mjs";
import { V as VaModalPlugin } from "../../../components/va-modal/plugin/index-970b6716.mjs";
import { d as defineVuesticPlugin } from "../utils/define-vuestic-plugin-8c565dfe.mjs";
const createVuestic = defineVuesticPlugin((options = {}) => ({
  install(app) {
    const { config } = options;
    setCurrentApp(app);
    Object.entries(vuesticComponents).forEach(([name, component]) => {
      app.component(name, component);
    });
    usePlugin(app, GlobalConfigPlugin(config));
    usePlugin(app, CachePlugin);
    usePlugin(app, ColorConfigPlugin(config));
    usePlugin(app, ColorsClassesPlugin);
    usePlugin(app, BreakpointConfigPlugin);
    usePlugin(app, VaDropdownPlugin);
    usePlugin(app, VaToastPlugin);
    usePlugin(app, VaModalPlugin);
    setCurrentApp(null);
  }
}));
export {
  createVuestic as c
};
//# sourceMappingURL=create-vuestic-e21b4a13.mjs.map
